import { Component, Input, OnInit } from '@angular/core';
import {
  AlignLeft,
  ChevronDown,
  ChevronUp,
  LogOut,
  LucideAngularModule,
  Menu,
  PanelRightClose,
  PanelRightOpen,
  User,
  UserCog,
  X,
} from 'lucide-angular';
import { SidebarStateService } from '../sidebar/sidebar-state.service';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { UserModel } from '@app/users/shared/user.model';
import { assetUrl } from '@app/shared/utils/asset-url.util';
import { SwitchUserService, SwitchUserStatus } from '@app/auth/switch-user.service';
import { SwitchUserBannerComponent } from '@app/partials/switch-user/switch-user-banner.component';
import { SwitchUserModalComponent } from '@app/partials/switch-user/switch-user-modal.component';

@Component({
  selector: 'app-header',
  imports: [LucideAngularModule, NgClass, NgOptimizedImage, RouterLink, SwitchUserBannerComponent, SwitchUserModalComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  standalone: true,
})
export class HeaderComponent implements OnInit {
  @Input() showSidebarToggle = true;
  protected readonly User = User;
  protected readonly logoUrl = assetUrl('images/the-venue-group-logo.svg');

  protected sidebarExpanded?: boolean;
  protected menuOpen = false;
  protected dropdownOpen = false;
  protected user?: UserModel | null = null;
  // TVG-378: pre-production-only switch user; null wherever the API says no.
  protected switchUserStatus: SwitchUserStatus | null = null;
  protected switchUserModalOpen = false;
  protected readonly UserCogIcon = UserCog;

  protected readonly PanelRightOpenIcon = PanelRightOpen;
  protected readonly PanelRightCloseIcon = PanelRightClose;
  protected readonly XIcon = X;
  protected readonly AlignLeftIcon = AlignLeft;
  protected readonly MenuIcon = Menu;

  constructor(
    private sidebarStateService: SidebarStateService,
    private authService: AuthService,
    private switchUserService: SwitchUserService,
  ) {}

  ngOnInit(): void {
    this.sidebarExpanded = this.sidebarStateService.isExpanded();
    this.sidebarStateService.stateChange.subscribe((state: boolean) => {
      this.sidebarExpanded = state;
    });
    this.switchUserService.status$.subscribe((status) => {
      this.switchUserStatus = status;
    });
    this.authService.getUser().subscribe({
      next: (user) => {
        this.user = user;
        this.switchUserService.loadStatus(user?.roles ?? []);
      },
      error: () => {
        this.user = null;
      },
    });
  }

  toggleSidebar(): void {
    this.sidebarStateService.toggleSidebar();
  }

  protected readonly LogOutIcon = LogOut;
  protected readonly ChevronUpIcon = ChevronUp;
  protected readonly ChevronDownIcon = ChevronDown;

  openSwitchUser(): void {
    this.dropdownOpen = false;
    this.switchUserModalOpen = true;
  }

  logout() {
    // TVG-378: while viewing as someone else, signing out ends only that
    // session and returns the admin to their own account.
    if (this.switchUserStatus?.switched_from) {
      this.switchUserService.switchBack().subscribe();
      return;
    }
    this.authService.logout();
  }
}
